import script from "./ForgotPasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordModal.vue?vue&type=style&index=0&id=98db49a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98db49a0"]])

export default __exports__